import { logError } from '@/lib/sentry.lib';

import { useState } from 'react';

import { DocumentResponseFormatDtoResponseFormatEnum } from '@repo/api-types/docusign';
import { useViewSignRequestDocuments } from '@repo/hooks';
import { translate } from '@repo/phrase';
import { getNotifier } from '@repo/utils';

import { getServiceBaseUrl } from '@/api/helpers.api';
import { getAppConfig } from '@/utils/window.utils';

export const useDocumentView = () => {
    const basePath = getServiceBaseUrl(getAppConfig().api.services.orderTaking, 'docusign');
    const viewDocumentMutation = useViewSignRequestDocuments(basePath);
    const [processingRowId, setProcessingRowId] = useState<string | null>(null);

    const viewDocument = async (signRequestId: string) => {
        setProcessingRowId(signRequestId);
        try {
            const blob = await viewDocumentMutation.mutateAsync({
                id: signRequestId,
                responseFormat: DocumentResponseFormatDtoResponseFormatEnum.combined,
            });

            const url = URL.createObjectURL(blob);
            globalThis.open(url, '_blank');
            setTimeout(() => {
                URL.revokeObjectURL(url);
            }, 1000);
        } catch (error) {
            logError(error);
            getNotifier()?.add({
                title: translate('docusign_document_view_failed'),
                type: 'error',
            });
        } finally {
            setProcessingRowId(null);
        }
    };

    return {
        viewDocument,
        isProcessing: (rowId: string) => processingRowId === rowId,
    };
};
